import _ from "underscore";

_.templateSettings = {
  interpolate: /\{%=([\s\S]+?)%\}/g,
  escape: /\{%-([\s\S]+?)%\}/g,
  evaluate: /\{%([\s\S]+?)%\}/g
};

export default function render(html, data={}){
  html = html || "";
  const template = _.template(html);
  data = _.extend({}, data, {render, _});
  // mitigate undefined issues for optional keys
  data.optional = _.extend({}, data);
  return template(data);
}


// WEBPACK FOOTER //
// ./src/utilities/render/index.js